import useTypedSWR from 'src/components/general/useTypedSWR';
import { MDT_REFRESH_INTERVAL } from 'src/myDayToday/constants';
import { GET_MY_DAY_TODAY_CURRENT_STATUS_QUERY } from 'src/myDayToday/hooks/useMyDayTodayCurrentStatus.gql';

export function useMyDayTodayCurrentStatus(providerId: string | null | undefined) {
  const { data, isLoading, error } = useTypedSWR(
    providerId ? [GET_MY_DAY_TODAY_CURRENT_STATUS_QUERY, { providerId }] : null,
    {
      keepPreviousData: true,
      refreshInterval: MDT_REFRESH_INTERVAL,
      revalidateIfStale: true,
    },
  );

  return {
    currentStatus: data?.staff_myDayTodayCurrentStatus ?? null,
    isLoading,
    error,
  };
}
